import { ComponentProps } from "react";
import Markdown from "react-native-markdown-display";
import { ImageProps, styled, Text, Image as TGImage, useMedia } from "tamagui";

const SurveyTransitionTitle = styled(Text, {
  name: "SurveyTransitionTitle",
  fontFamily: "$subtitle",
  color: "$gray-primary-900",
  variants: {
    font: {
      lg: {
        fontWeight: "$7",
        fontSize: "$8",
        lineHeight: "$8",
      },
      md: {
        fontWeight: "$6",
        fontSize: "$6",
        lineHeight: "$6",
        textAlign: "center",
      },
    },
  } as const,
  defaultVariants: {
    font: "lg",
  },
});

type SurveyTransitionDescriptionProps = ComponentProps<typeof Markdown>;

const SurveyTransitionDescription: React.FC<
  SurveyTransitionDescriptionProps
> = ({ children, ...rest }) => {
  const { sm } = useMedia();

  return (
    <Markdown
      style={{
        body: {
          fontWeight: 500,
          color: "#23252A",
          fontFamily: "Fixel Text",
          ...(!sm && {
            fontSize: 20,
            lineHeight: 30,
          }),
          ...(sm && {
            fontSize: 16,
            lineHeight: 24,
          }),
        },
      }}
      {...rest}
    >
      {children}
    </Markdown>
  );
};

const SurveyTransitionImage: React.FC<ImageProps> = (props) => {
  return (
    <TGImage
      resizeMode={"contain"}
      width={"100%"}
      maxWidth={570}
      maxHeight={570}
      $sm={{
        maxWidth: 240,
        maxHeight: 240,
      }}
      {...props}
    />
  );
};

export const SurveyTransition = {
  Image: SurveyTransitionImage,
  Description: SurveyTransitionDescription,
  Title: SurveyTransitionTitle,
};
